export const userFilterData = (state) => state.appUser;
export const playerReportCard = (state) => state.multipleReportCards;
export const appUser = (state) => state.appUser;
const cleanData = data => {
    if (data) {
        if (Array.isArray(data)) return data
        else if (typeof data == "string" && data.length > 0) return [data]
        else return []
    } else {
        return []
    }
}

export const fetchUserParams = (state) => {
    const appUser = state.appUser;
    const AppUserFilter = state.form.AppUserFilter
    let filterParams = {};
    if (AppUserFilter) {
        const {
            username,
            first_name,
            last_name,
            alias,
            businessList,
            roles,
            coachList,
            playerTypeList
        } = AppUserFilter.values;

        filterParams = {
            username,
            first_name,
            last_name,
            alias,
            selectedRoles: roles ? roles : [],
            business: cleanData(businessList),
            playerType: playerTypeList ? playerTypeList : [],
            assigned_to: coachList ? coachList : []
        }
    } else {
        filterParams = {
            username: '',
            first_name: '',
            last_name: '',
            alias: '',
            selectedRoles: appUser.roles.map(role => role._id),
            business: appUser.business.map(business => business._id),
            playerType: appUser.playerTypeList.map(playerType => playerType._id),
            assigned_to: appUser.coachList.map(coach => coach._id),
        }
    }
    return ({
        max: appUser.max,
        offset: (appUser.pageNo - 1) * appUser.max,
        sortBy: appUser.sortBy,
        column: appUser.currColumn,
        userRole: JSON.parse(localStorage.getItem('userRole')),
        ...filterParams
    })
}



/** WEBPACK FOOTER **
 ** ./src/store/selectors.js
 **/